<div
  data-rslib-webcomponent-load="rslib.apps.progressbar"
  class="rs-usage-progress"
>
  <div class="rs-usage-progress-title">
    <div class="rs-flex-row">
      <div class="rs-flex-column" data-cy="instalmentPlanPaidAmount">
        {{ 'bills.instalment.paidCapitalLetter' | translate }}
        <br class="show-for-small-only" /><strong
          ><px-currency-amount
            [amount]="instalmentPlanInformation.paidAmount"
          ></px-currency-amount
        ></strong>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div class="text-right" data-cy="instalmentPlanToPayAmount">
          {{ 'bills.instalment.toPay' | translate }}
          <br class="show-for-small-only" /><strong
            ><px-currency-amount [amount]="amountToPay"></px-currency-amount
          ></strong>
        </div>
      </div>
    </div>
  </div>
  <lib-progress-bar
    [isUsageBar]="true"
    [inputProgressBarContent]="progressBarContent"
  >
  </lib-progress-bar>
</div>
